import http from './http'

let showLoading = false

//项目基本信息(详情)
export const getProBasicInfo = projectId => {
	return http({ method: 'get', url: `/heating/api/pro/basicInfo/${projectId}` })
}

// //统计项目数量
// export const getProCount = () => {
// 	return http({ method: 'get', url: '/heating/api/pro/count' })
// }

//项目名称列表
export const getProNameList = () => {
	return http({ method: 'get', url: `/heating/api/pro/nameList` })
}

//项目列表
export const getProList = data => {
	return http({ method: 'post', url: '/heating/api/pro/list', data })
}

//导出
export const exportExl = data => {
	return http({ method: 'post', url: '/heating/api/pro/proExport', data, imgUrl: true })
}


//获取天气
export const getWeather = data => {
	return http({ method: 'post', url: '/heating/api/pro/proRegionCode', data, showLoading })
}

//获取具体data
export const getData = data => {
	return http({ method: 'post', url: '/heating/api/pro/proAttr', data, showLoading })
}


// //获取具体data
// export const getStatusList = data => {
// 	return http({ method: 'post', url: '/heating/api/pro/statusList', data, showLoading })
// }

//获取具体data
export const getStatusList = () => {
	return http({ method: 'get', url: '/heating/api/pro/statusList', showLoading })
}